module.exports = __webpack_public_path__ + "assets/campaign/img/logo-charity.706b7ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-charity.png
// module id = TaGi
// module chunks = 1